// eslint-disable-next-line
import React from 'react';
import DataSheetBase from './DataSheetBase.js';

export default class DataSheet_localizationSheet extends DataSheetBase {

  constructor(id, updateCb) {
    super(id, updateCb);
    this.requestedKeyPath = "";  // this value can be specified in the React Studio data sheet UI
  }

  makeDefaultItems() {
    // eslint-disable-next-line no-unused-vars
    let key = 1;
    // eslint-disable-next-line no-unused-vars
    let item;
    
    item = {};
    this.items.push(item);
    item['key'] = "start_iconbutton_401543";
    item['en'] = "Icon button";
    
    item = {};
    this.items.push(item);
    item['key'] = "start_button_578306";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "comp1_button_331254";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "comp1_button_1022806";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "component1_button_101977";
    item['en'] = "MINT";
    
    item = {};
    this.items.push(item);
    item['key'] = "mint_buttom_textblock_392574";
    item['en'] = "TBD";
    
    item = {};
    this.items.push(item);
    item['key'] = "mint_buttom_textblock2_476561";
    item['en'] = " ";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_button_74151";
    item['en'] = "ENTER";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_button_1040670";
    item['en'] = "DEMO";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_text_547409";
    item['en'] = "the kint in not open. wait for the announcements in our Channels";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_text_662737";
    item['en'] = "The Minting is not open. Wait for the announcement in our channels";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_button_469464";
    item['en'] = "OK";
    
    item = {};
    this.items.push(item);
    item['key'] = "component1_button_147520";
    item['en'] = "Whitepaper";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_text_299877";
    item['en'] = "The $KEY MINTING IS NOT OPEN. PLEASE CHECK THE ANNOUNCEMENTS CHANNEL IN OUR DISCORD FOR THE MINTING EVENT DATE.";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_text_770135";
    item['en'] = ". portsy ar app launch\n. create ar portals for free";
    
    item = {};
    this.items.push(item);
    item['key'] = "comp1_text_517192";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy_27460";
    item['en'] = ". Mnemosyne metaverse demo 1\n. mnemosyne website\n. social media activation";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy2_846069";
    item['en'] = "\n";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy3_849199";
    item['en'] = ". menemosyne demo 2 onchain\n. open portals to mnemosyne metaverse\n. menemosyne metaverse launch\n. access to mnemosyne metaverse\n. STAKE KEYS\n. CLOSING FREE PORTALS\n. Portsy AR SOLANA WALLET launch";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy4_353864";
    item['en'] = ". DAO launch and land distribution\n. land certificates\n. mnemosyne. metaverse ver 1.0\n. mnemosyne temples unification\n. portal jumping\n. portal share / lending";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_text2_272740";
    item['en'] = ". $MEMP token launch\n. $forgp synthetic token\n. menemosyne pool";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy2_680930";
    item['en'] = ". menemosyne ver 0.1\n. $MEMP token launch\n. Mnemosyne Liquidity POOL\n. $forgp synthetic token launch\n. lethe liquity pool\n. Memoirs deposits";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy5_106434";
    item['en'] = ". treasury vaults launch\n. mnemosyne guilds\n. lethe guilds\n. portals tunneling\n. ";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_text2_907850";
    item['en'] = "2021 q3";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy6_463419";
    item['en'] = "2022 q1";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy7_839491";
    item['en'] = "2022 q2";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy8_95073";
    item['en'] = "2022 q3";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy9_271984";
    item['en'] = "2022 q4";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_textcopy10_916953";
    item['en'] = "2023 q1";
    
    item = {};
    this.items.push(item);
    item['key'] = "component4_text_393748";
    item['en'] = "Mnemosyne had a dream, creating a place where only the good memories could live in joy, where time doesn't exist, the place should take your name, Mnemosyne Metaverse.";
    
    item = {};
    this.items.push(item);
    item['key'] = "component5_textblock_910373";
    item['en'] = "TEAM";
    
    item = {};
    this.items.push(item);
    item['key'] = "component5_text_590005";
    item['en'] = "New text. Double-click to edit";
    
    item = {};
    this.items.push(item);
    item['key'] = "component6_button_1014898";
    item['en'] = "ENTER METVAVERSE";
    
    item = {};
    this.items.push(item);
    item['key'] = "aboutourpassion_text3_958684";
    item['en'] = ". Tokenomics\n. mint KEYS\n. mint Portals";
    
    item = {};
    this.items.push(item);
    item['key'] = "component6_button_669102";
    item['en'] = "ENTER METAVERSE";
    
    item = {};
    this.items.push(item);
    item['key'] = "themnemosynetitle2_textblock_1047962";
    item['en'] = "PORTSY AR APP";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_text_302602";
    item['en'] = "The Key grants to the mortals the unique possibility to keep those memories alive for the perpetuity, and only those with the key can eventually enter the Mnemosyne Metaverse to travel time and re-experience the moments back in time.";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_text_192732";
    item['en'] = "TBA";
    
    item = {};
    this.items.push(item);
    item['key'] = "component2_text_251294";
    item['en'] = "Start Creating your Own Portals for Free Around the Real World\n";
    
    item = {};
    this.items.push(item);
    item['key'] = "component3_textblock_386364";
    item['en'] = "After the key mint you will connect the portals you’ve created in portsy ar to your mnemosyne land, allowing others to visiti your memoirs.";
    
    item = {};
    this.items.push(item);
    item['key'] = "downloadnow_textblock_80370";
    item['en'] = "DOWNLOAD PORTSY AR NOW";
    
    item = {};
    this.items.push(item);
    item['key'] = "downloadnow_button_1047195";
    item['en'] = "New button";
    
    item = {};
    this.items.push(item);
    item['key'] = "downloadnow_button_550105";
    item['en'] = "New button";
    
    let storedItems = localStorage.getItem(this.id);
    if (storedItems != null) {
      this.items = JSON.parse(storedItems);
    }
  }

  addItem(item, options) {
    super.addItem(item, options);
    
    localStorage.setItem(this.id, JSON.stringify(this.items));
  }

  removeItem(item, options) {
    super.removeItem(item, options);
    
    localStorage.setItem(this.id, JSON.stringify(this.items));
  }

  replaceItemByRowIndex(idx, newItem, options) {
    super.replaceItemByRowIndex(idx, newItem, options);
    
    localStorage.setItem(this.id, JSON.stringify(this.items));
  }

  getStringsByLanguage = () => {
    let stringsByLang = {};
    for (let row of this.items) {
      const locKey = row.key;
      for (let key in row) {
        if (key === 'key')
          continue;
        let langObj = stringsByLang[key] || {};
        langObj[locKey] = row[key];
        stringsByLang[key] = langObj;
      }
    }
    return stringsByLang;
  }

}
